import React from 'react';
import ProductCard from '../ProductCard/ProductCard'; // Assuming this path is correct based on component creation

interface MainContentProps {
  products?: any[]; // Placeholder for product array
}

const MainContent: React.FC<MainContentProps> = ({ products }) => {
  return (
    <main className="main-content" style={{ paddingBottom: '40px' }}>
      <h1 style={{ textAlign: 'center' }}>Nos Prestations</h1>
      <div className="product-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
        {products && products.length > 0 ? (
          products.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))
        ) : (
          <p>Balade et randonnée à la carte</p>
        )}
      </div>
    </main>
  );
};

export default MainContent;